import React from "react";
import { Container, Row, Col, CardImg } from "reactstrap";
import "../styles/about.css"; // Import custom CSS

const About = () => {
  return (
    <Container className="mt-5">
      {/* About Us Section */}
      <Row className="mb-4">
        <Col>
          <h1>About Us</h1>
          <CardImg src="/images/about-us-image.jpg" alt="About Us Image" className="section-img" />
          <p>
            Welcome to Parth Vacations, where every journey is crafted to create lasting memories. As a premier travel company, we specialize in delivering exceptional travel experiences tailored to your unique desires and preferences. Whether you're seeking a relaxing beach getaway, a thrilling adventure, or a culturally immersive experience, Parth Vacations has the perfect itinerary for you.
          </p>
        </Col>
      </Row>

      {/* Mission and Vision Section */}
      <Row className="mb-4">
        <Col md="6">
          <h2>Our Mission</h2>
          <p>
            At Parth Vacations, our mission is to provide personalized, high-quality travel experiences that exceed our clients' expectations. We aim to make travel planning seamless and enjoyable, ensuring that every trip is a delightful adventure from start to finish.
          </p>
        </Col>
        <Col md="6">
          <CardImg top src="/group-tour/illustration-business-target-icon.png" alt="Our Mission Image" className="section-img" />
        </Col>
      </Row>

      <Row className="mb-4 reverse">
        <Col md="6">
          <CardImg top src="/group-tour/hand-drawn-business-icons-design.png" alt="Our Vision Image" className="section-img" />
        </Col>
        <Col md="6">
          <h2>Our Vision</h2>
          <p>
            Our vision is to be the leading travel company, known for our commitment to excellence and our passion for travel. We aim to inspire people to explore new destinations and to create unforgettable travel experiences.
          </p>
        </Col>
      </Row>

      {/* Core Values Section */}
      <Row className="mb-4">
        <Col md="4">
          <CardImg top src="/group-tour/award-ribbon-check-mark-with-stars.png" alt="Quality Service Image" className="section-img" />
          <h4>Quality Service</h4>
          <p>
            We believe in providing the highest quality of service to our customers. Our team is available 24/7 to assist you with any travel-related inquiries or issues related to travel.
          </p>
        </Col>
        <Col md="4">
          <CardImg top src="/group-tour/collaborative-concept-illustration.png" alt="Experienced Team Image" className="section-img" />
          <h4>Experienced Team</h4>
          <p>
            Our team of travel experts has years of experience in the industry. We use our knowledge and expertise to help you plan the perfect trip, tailored to your preferences and budget.
          </p>
        </Col>
        <Col md="4">
          <CardImg top src="/group-tour/emoji-ratings-set.png" alt="Customer Satisfaction Image" className="section-img" />
          <h4>Customer Satisfaction</h4>
          <p>
            Customer satisfaction is our top priority. We go above and beyond to ensure that our customers are happy with their travel experiences. Your feedback is important to us.
          </p>
        </Col>
      </Row>

      {/* Why Choose Us Section */}
      <Row className="mb-4">
        <Col>
          <h2>Why Choose Us?</h2>
          <ul className="why-choose-us">
            <li><strong>One Line Tour Price, Always All Inclusive. No Additions - No Confusion, No Hidden Costs.</strong></li>
            <li><strong>No Advertising Gimmicks. No Optional Sightseeing. No Extra Expenses to be paid on tour.</strong></li>
            <li><strong>USP - Indian Food: One of the unique selling points (USP) of Parth Vacations is the inclusion of Indian food on their tours. This is a significant advantage for travellers who prefer familiar cuisine while exploring different parts of the world.</strong></li>
            <li><strong>Expert Planning: Our team of experienced travel consultants is dedicated to understanding your travel needs and crafting the perfect itinerary. We take care of all the details, so you can focus on enjoying your trip.</strong></li>
            <li><strong>We are committed to promoting sustainable and responsible travel practices. We partner with eco-friendly resorts and tour operators to minimize our environmental impact and support local communities.</strong></li>
            <li><strong>Comfortable AC Luxury Coaches, Maximum sightseeing included.</strong></li>
            <li><strong>24/7 Support: Travel with confidence knowing that our dedicated support team is available around the clock to assist you with any queries or concerns, ensuring a hassle-free travel experience.</strong></li>
            <li><strong>Lots of Extra Toppings like Ice cream, soft drinks, etc. on tour, special Snack Hamper at the airport.</strong></li>
            <li><strong>Complimentary Bag at the time of final payment.</strong></li>
            <li><strong>Lots of Entertainment on tour, hassle-free travel.</strong></li>
            <li><strong>Professional & Caring Tour Leader throughout the tour.</strong></li>
            <li><strong>Customized Packages: No two travellers are the same. We offer a wide range of customizable travel packages to suit every budget, interest, and travel style. Whether it's a romantic honeymoon, a family vacation, or a solo adventure, we have you covered.</strong></li>
            <li><strong>Exclusive Destinations: Discover hidden gems and iconic destinations with our exclusive travel packages. From serene tropical beaches to bustling cityscapes and everything in between, Parth Vacations opens the door to a world of possibilities.</strong></li>
            <li><strong>Brand Range of World Wide Tours.</strong></li>
            <li><strong>Tours suitable for Every duration consisting of 3 to 40 days with many combinations.</strong></li>
            <li><strong>Tours suitable for Every Budget, starting from 5 thousand to 10 lakh.</strong></li>
            <li><strong>Tours for Every Lifestyle - luxury tours, upgraded tours, cost saver tours, Tailor-made Holidays.</strong></li>
          </ul>
        </Col>
      </Row>

      {/* MICE Section */}
      <Row className="mb-4">
        <Col md="6">
          <h2>MICE</h2>
          <p>
            In the ever-evolving business landscape, Meetings, Incentives, Conferences, and Exhibitions (MICE) are vital to every successful organization. As companies increasingly allocate larger budgets to MICE activities and explore global venues, there is a growing demand for high-quality MICE operators. Parth Vacations rises to meet this demand with unparalleled expertise and a dedicated team.
            <ul className="mice-services">
              <li><strong>Meeting Coordination: From intimate team gatherings to large corporate assemblies, we meticulously plan and execute every detail.</strong></li>
              <li><strong>Incentive Travel Programs: We craft unforgettable incentive travel experiences that motivate and reward your employees, fostering loyalty and performance.</strong></li>
              <li><strong>Conference Management: Our comprehensive conference management services ensure your event is impactful and seamless.</strong></li>
              <li><strong>Exhibition Services: We support the organization and management of exhibitions, helping you effectively showcase your business.</strong></li>
            </ul>
          </p>
        </Col>
        <Col md="6">
          <CardImg src="/group-tour/pikaso_texttoimage_Meetings-Incentives-Conferences-and-Exhibitions-MI.jpeg" alt="MICE Services Image" className="section-img" />
        </Col>
      </Row>

      {/* Tailor-made Holidays Section */}
      <Row className="mb-4 reverse">
        <Col md="6">
          <CardImg src="/group-tour/group-friends-looking-map.jpg" alt="Tailor-made Holidays Image" className="section-img" />
        </Col>
        <Col md="6">
          <h2>Tailor-made Holidays</h2>
          <p>
            At Parth Vacations, we understand that every traveller is unique. That's why we offer tailor-made holidays that are designed to suit your individual preferences and interests. Whether you’re looking for a serene escape, an adventurous journey, or a cultural exploration, we create bespoke travel experiences that match your vision perfectly.
          </p>
        </Col>
      </Row>

      {/* Corporate Tours Section */}
      <Row className="mb-4">
        <Col md="6">
          <h2>Corporate Tours</h2>
          <p>
            We specialize in organizing corporate tours that cater to the needs of businesses and their employees. From team-building retreats to executive getaways, our corporate tour packages are designed to enhance team cohesion, provide networking opportunities, and offer a refreshing break from the daily grind.
          </p>
        </Col>
        <Col md="6">
          <CardImg src="/group-tour/portrait-business-people-worker-team-outside.jpg" alt="Corporate Tours Image" className="section-img" />
        </Col>
      </Row>

      {/* Group Tours Section */}
      <Row className="mb-4 reverse">
        <Col md="6">
          <CardImg src="/group-tour/medium-shot-happy-friends-group.jpg" alt="Group Tours Image" className="section-img" />
        </Col>
        <Col md="6">
          <h2>Group Tours</h2>
          <p>
            Our group tours are perfect for friends, families, and organizations looking to travel together. We handle all the logistics, from accommodation to transportation, ensuring that your group enjoys a smooth and enjoyable travel experience. Whether it's a family vacation, a school trip, or a club excursion, we have the expertise to make it memorable.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
